import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Globe } from "lucide-react";
import { useLang } from "../contexts/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-[hsl(var(--secondary))]/40 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-baseline gap-3 mb-3" data-testid="footer-brand">
            <span className="brand-mark text-5xl">Tæste</span>
            <span className="text-sm font-semibold tracking-wide text-[hsl(var(--foreground))]">GbR</span>
          </div>
          <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-xs">{t.footer.tagline}</p>
        </div>
        <div className="space-y-3 text-sm">
          <p className="eyebrow mb-2">Kontakt</p>
          <a href="mailto:info@taeste.de" data-testid="footer-email" className="flex items-center gap-2 hover:underline">
            <Mail size={14} /> info@taeste.de
          </a>
          <a href="tel:+4915129402613" data-testid="footer-phone" className="flex items-center gap-2 hover:underline">
            <Phone size={14} /> +49 1512 9402613
          </a>
          <a href="https://taeste.de" data-testid="footer-web" className="flex items-center gap-2 hover:underline">
            <Globe size={14} /> taeste.de
          </a>
          <a
            href="https://instagram.com/taeste.catering_streetfood"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="flex items-center gap-2 hover:underline"
          >
            <Instagram size={14} /> @taeste.catering_streetfood
          </a>
        </div>
        <div className="space-y-3 text-sm">
          <p className="eyebrow mb-2">Mehr</p>
          <Link to="/kontakt" data-testid="footer-contact-link" className="block hover:underline">
            {t.nav.contact}
          </Link>
          <Link to="/galerie" data-testid="footer-gallery-link" className="block hover:underline">
            {t.nav.gallery}
          </Link>
          <Link to="/impressum" data-testid="footer-imprint-link" className="block hover:underline">
            {t.footer.imprint}
          </Link>
          <Link to="/datenschutz" data-testid="footer-privacy-link" className="block hover:underline">
            {t.footer.privacy}
          </Link>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[hsl(var(--muted-foreground))]">
          <p>© {new Date().getFullYear()} Tæste GbR — {t.footer.rights}</p>
          <p>Annabell & Edgar</p>
        </div>
      </div>
    </footer>
  );
}
